import { useEffect, useMemo } from 'react';
import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import { useCoinGeckoPrices } from '@/shared/hooks/useCoinGeckoPrices';
import { chainflipAssetMap } from '@/shared/utils/env';
import useSupportedAssets from './useSupportedAssets';

const useChainflipAssetPrices = () => {
  const { watchTokens, getPrice, isLoading } = useCoinGeckoPrices();
  const chainflipAssets = useSupportedAssets();

  const tokens = useMemo(
    () => chainflipAssets.map((asset) => chainflipAssetMap[asset]),
    [chainflipAssets],
  );
  useEffect(() => watchTokens(tokens), [tokens]);

  const prices = Object.fromEntries(
    chainflipAssets.map((asset) => [asset, getPrice(chainflipAssetMap[asset])]),
  ) as Record<ChainflipAsset, number | undefined>;

  return {
    isLoading,
    prices,
  };
};

export default useChainflipAssetPrices;
